import "./HotelTechStackConsulting.module.css";
import Header from "@/reusable_sections/Header";
import ConsultingHero from "./sections/ConsultingHero";
import RevenueJourneyContact from "./sections/RevenueJourneyContact";
import TechIntegration from "./sections/TechIntegration";
import Technicalfaq from "./sections/Technicalfaq";
import Techstackauditcta from "./sections/Techstackauditcta";
import Footer from "@/reusable_sections/Footer";
export default function HotelTechStackConsultingPage() {
  return <div>
      <Header />
      <ConsultingHero />
      <RevenueJourneyContact />
      <TechIntegration />
      <Technicalfaq />
      <Techstackauditcta />
      <Footer />
    </div>;
}